import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';

import Button from '../../components/Button';
import InformationPanel from '../../components/InformationPanel';
import Modal from '../../components/Modal';
import { currencyFormattedNumber } from '../../lib/numberFormatter';
import { periodTitle } from '../../lib/periodUtils';
import { periodPropTypes } from '../../reducers/propTypes';

const CostOfAttendanceBreakdownModal = ({ periods, currentPeriod }) => {
  const [showModal, setModal] = useState(false);

  const openModal = () => setModal(true);
  const closeModal = () => setModal(false);

  const renderPeriods = () => {
    return (
      <div className="row-spacer">
        {periods.map((period, index) => {
          const { costOfTuition, costOfLiving } = period;

          return (
            <table key={period.periodGuid}>
              <thead>
                <tr>
                  <th className="text-heavy">{periodTitle(period)}</th>
                  <th className="text-right">
                    {currencyFormattedNumber(period.currency, costOfTuition + costOfLiving)}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Cost of tuition</td>
                  <td className="text-right">
                    {currencyFormattedNumber(period.currency, costOfTuition)}
                  </td>
                </tr>
                <tr>
                  <td>Cost of living</td>
                  <td className="text-right">
                    {currencyFormattedNumber(period.currency, costOfLiving)}
                  </td>
                </tr>
              </tbody>
            </table>
          );
        })}
      </div>
    );
  };

  const renderTotals = () => {
    let totalTuition = 0;
    let totalLiving = 0;
    let totalCostOfAttendance = 0;
    let currency = 'USD';

    periods.forEach((period, index) => {
      const { currency: periodCurrency, costOfTuition, costOfLiving } = period;
      currency = periodCurrency;
      totalCostOfAttendance += costOfTuition + costOfLiving;
      totalTuition += costOfTuition;
      totalLiving += costOfLiving;
    });

    return (
      <table>
        <thead className="table-head--emphasised">
          <tr>
            <th>Total for your course</th>
            <th className="text-right">
              {currencyFormattedNumber(currency, totalCostOfAttendance)}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Total cost of tuition</td>
            <td className="text-right">{currencyFormattedNumber(currency, totalTuition)}</td>
          </tr>
          <tr>
            <td>Total cost of living</td>
            <td className="text-right">{currencyFormattedNumber(currency, totalLiving)}</td>
          </tr>
        </tbody>
      </table>
    );
  };

  return (
    <Fragment>
      <Button onClick={openModal} theme="inline-link">
        See the breakdown for your course.
      </Button>

      <Modal
        isOpen={showModal}
        title="Here is the breakdown of your costs:"
        onClose={closeModal}
        footer={renderTotals()}
      >
        <div className="row-spacer">
          <InformationPanel>
            <p className="no-margin-top no-margin-bottom">
              We work closely with your school to get the tuition and recommended living costs so
              you can plan your finances accurately.
            </p>
          </InformationPanel>
        </div>

        {renderPeriods()}
      </Modal>
    </Fragment>
  );
};

CostOfAttendanceBreakdownModal.propTypes = {
  periods: PropTypes.arrayOf(periodPropTypes).isRequired,
  currentPeriod: PropTypes.string.isRequired,
};

export default CostOfAttendanceBreakdownModal;
